import videojs from 'video.js';
import './button.js';
import './aside-container.js';
import './videojs-custom-info.scss';
import { checkTouchScreen } from '../../js/helpers/checkTouchScreen';

const Plugin = videojs.getPlugin('plugin');

// Default options for the plugin.
const defaults = {
	buttonTitle: 'Info',
	content: () => 'Info content',
	onShow: () => {},
	statsUrl: '',
	mobileBreakpoint: '480',
	fullHeightBreakpoint: 1024,
	isAvailable: true,
	requestAccess: () => {},
	onReady: () => {}
};

class customInfo extends Plugin {
	constructor(player, opts) {
		super(player);

		this.setState(videojs.mergeOptions(defaults, opts));

		this.asideContainer;
		this.showContent = this.showContent.bind(this);

		this.init();
	}

	init() {
		this.player.on('ready', () => {
			this.initAsideContainer();
			this.initCustomInfoButton();
			this.setListeners();
		})
	}

	initAsideContainer() {
		this.asideContainer = this.player.addChild(
			'AsideContainer',
			videojs.mergeOptions(
				this.state,
				{
					show: (contentEl) => {
						this.showContent(
							() => {
								this.asideContainer.hide();
								this.asideContainer.show();
							},
							contentEl
						);
					}
				}
			)
		);

		this.asideContainer.on('AsideContainer/show', () => this.player.addClass('vjs-custom-info-open'));
		this.asideContainer.on('AsideContainer/hide', () => this.player.removeClass('vjs-custom-info-open'));

		this.state.onReady();
	}

	initCustomInfoButton() {
		const controlBar = this.player.getChild('controlBar');
		if (!controlBar) return;

		const customControlSpacer = controlBar.getChild('customControlSpacer');
		const customControlSpacerIndex = customControlSpacer && controlBar.children_.indexOf(customControlSpacer) + 1;

		const customInfoButton = controlBar.addChild(
			'customInfoButton',
			videojs.mergeOptions(this.state, { container: this.asideContainer }),
			customControlSpacerIndex
		);

		if (!this.state.isAvailable) {
			customInfoButton.addClass('vjs-custom-info__button_restricted');
		}
	}

	setListeners() {
		// Закрытие кликом вне контейнера
		const handleClick = (event) => {
			const ignoredItems = [
				'.vjs-multicam__switch-button',
				'.vjs-aside-container',
				'.vjs-custom-info__button'
			];
			if (this.player.currentWidth() >= 1024) {
				ignoredItems.push('.vjs-multicam__list-cameras');
			}
			const isIgnoreItem = ignoredItems.some((className) => event.target.closest(className));
			if (isIgnoreItem) return;
			if (this.asideContainer.el() && !this.asideContainer.hasClass('vjs-hidden')) {
				this.asideContainer.hide();
			}
		};
		const eventName = checkTouchScreen() ? 'touchstart' : 'click';
		document.addEventListener(eventName, handleClick);
		this.player.on('dispose', () => {
			document.removeEventListener(eventName, handleClick);
		});
	}

	async showContent(handleError, contentEl) {
		try {
			const [ stats ] = await Promise.all([
				fetch(this.state.statsUrl)
					.then(resp => resp.json())
			]);
			this.setState(videojs.mergeOptions(this.state, {stats: stats}));
			contentEl.innerHTML = this.state.content(stats);
			this.state.onShow({
				container: contentEl,
				player: this.player,
				hideContainer: () => this.asideContainer.hide()
			});
		} catch(error) {
			contentEl.innerHTML = this.state.content();
			this.state.onShow({
				container: contentEl,
				isError: true,
				retry: handleError
			});
		}
	}

	replaceNullToZero(data) {
		// JSON like object is only valid format
		if (data === null) {
			return 0;
		}
		if (Array.isArray(data)) {
			return data.map((val) => this.replaceNullToZero(val));
		}
		if (typeof data === 'object') {
			return Object.keys(data).reduce((acc, key) => {
				acc[key] = this.replaceNullToZero(data[key]);
				return acc;
			}, {});
		}
		return data;
	}
}

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
registerPlugin('customInfo', customInfo);
